import { render, staticRenderFns } from "./SuggestedAction.vue?vue&type=template&id=821a009e&scoped=true&"
import script from "./SuggestedAction.vue?vue&type=script&lang=ts&"
export * from "./SuggestedAction.vue?vue&type=script&lang=ts&"
import style0 from "./SuggestedAction.vue?vue&type=style&index=0&id=821a009e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "821a009e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VSubheader } from 'vuetify/lib/components/VSubheader';
installComponents(component, {VDivider,VIcon,VList,VListItem,VListItemContent,VSubheader})
